// Tells "this PDF needs a password" apart from other read failures, so a tool can say so and point to Unlock PDF.

export const LOCKED_PDF_MESSAGE = "This PDF is password-protected. Unlock it first, then drop the unlocked copy here.";

export function isPasswordError(err: unknown): boolean {
  if (!err) return false;
  const e = err as { name?: string; message?: string };
  return e.name === "PasswordException" || e.name === "EncryptedPDFError" || /password|encrypted/i.test(e.message ?? "");
}
